<div
  rkVideoPopover
  [props]="popover"
  class="flex items-center text-black/70 gap-1 cursor-pointer"
>
  <mat-icon fontSet="far" fontIcon="fa-lightbulb"></mat-icon>
  <div translate>GLOBAL.SHOW_TUTORIAL</div>
</div>
